import loadable from '@loadable/component';

export const ViewEventPageLoadable = loadable(() => import('./ViewEventPage'), {
  resolveComponent: (module) => module.ViewEventPage,
});
